import { blue, grey, lightGreen, yellow } from "@mui/material/colors";
import { CheckCircleOutlineRounded, DescriptionRounded, Pending } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { colorProductionStageOptions, productionStageOptions, publishWithRemarksColumn } from "components/PimDashboard/data";
import { stageTableColumn, statusOptions } from "data/globalData";

export const BUY_QTY_SHEET_API = "/api/buy_qty_sheet";
export const buyQtySheetFilterValStr = "buy_qty_sheet_filter_obj";
export const buyQtySheetAttrStorageStr = "buy_qty_sheet_table_attr";

export const buyQtyPublishColumns = {
	buy_qty_status: { name: "Buy Qty Status", key: "buy_qty_status" },
	buy_qty_published_by: { name: "Published By", key: "buy_qty_published_by" },
	buy_qty_published_date: { name: "Published Date", key: "buy_qty_published_date" },
};

export const buyQtyStatusOptions = {
	PENDING: { name: "Pending", key: "PENDING", color: blue[300], icon: <Pending fontSize="small" /> },
	DRAFT: { name: "Draft", key: "DRAFT", color: grey[300], icon: <DescriptionRounded fontSize="small" /> },
	PUBLISHED: {
		name: "Published",
		key: "PUBLISHED",
		color: lightGreen["A700"],
		icon: <CheckCircleOutlineRounded fontSize="small" />,
	},
};


export const buyQtyColorScopedKeys = ["stage", "status"];



export const buyQtyReservedGridFields = ["status", "url", "option_id", "buy_qty_status", "stage"];



export const isBuyQtyStyleScopedField = (row) =>

	buyQtyColorScopedKeys.includes(row?.key) && row?.linked_table === "style";



export const filterBuyQtyAttribute = (row) =>

	row?.key && !buyQtyReservedGridFields.includes(row.key) && !isBuyQtyStyleScopedField(row);



export const dedupeDataGridColumns = (columns = []) => {
	const seen = new Set();
	return columns.filter((col) => {
		const field = col?.field;
		if (!field || seen.has(field)) return false;
		seen.add(field);
		return true;
	});
};

export const parseStyleSizes = (value) => {
	if (Array.isArray(value)) {
		return value.map((size) => String(size ?? "").trim()).filter(Boolean);
	}

	if (typeof value === "string") {
		const trimmed = value.trim();
		if (!trimmed) return [];

		try {
			const parsed = JSON.parse(trimmed);
			if (Array.isArray(parsed)) {
				return parsed.map((size) => String(size ?? "").trim()).filter(Boolean);
			}
		} catch (error) {
			// fall through to comma-separated parsing
		}

		return trimmed
			.split(",")
			.map((size) => String(size ?? "").trim())
			.filter(Boolean);
	}

	return [];
};

export const resolveBuyQtyDisplayStatus = (buyQtyStatus) =>

	!buyQtyStatus ? buyQtyStatusOptions.PENDING.key : buyQtyStatus;



export const buyQtyStageColumn = () => ({
	...stageTableColumn({
		...colorProductionStageOptions,
		...productionStageOptions,
	}),
	minWidth: 120,
	width: 130,
});

export const buyQtyStatusColumn = () => {
	const statusCol = publishWithRemarksColumn(() => {}, true);

	const renderBuyQtyBadge = (row, statusKey) => {
		const meta = buyQtyStatusOptions[statusKey];

		return (
			<Box display="flex" height="100%" alignItems="center" justifyContent="center" columnGap={0.5}>
				<Box
					display="flex"
					alignItems="center"
					height={"22px"}
					sx={{
						backgroundColor: meta?.color || yellow[400],
						color: "white",
						padding: "4px 8px",
						borderRadius: "5px",
					}}>
					{meta?.icon}
					<Typography pl="3px" fontSize="12px" noWrap>
						{meta?.name ?? "----"}
					</Typography>
				</Box>
			</Box>
		);
	};

	return {
		...statusCol,
		field: buyQtyPublishColumns.buy_qty_status.key,
		headerName: buyQtyPublishColumns.buy_qty_status.name,
		renderCell: (params) => {
			const statusKey = resolveBuyQtyDisplayStatus(params.row?.buy_qty_status);

			if (statusKey === buyQtyStatusOptions.PUBLISHED.key) {
				return statusCol.renderCell({
					...params,
					row: { ...params.row, status: statusOptions.PUBLISHED.key },
				});
			}

			return renderBuyQtyBadge(params.row, statusKey);
		},
	};
};
